import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import webFormPageActions from '../actions/webFormPage';

// responds to 'CONTINUE_BUTTON' action
function createWebformAccount(store, action) {
    const leadFormUserInfo = action.payload.leadFormUserInfo;
    request.post(`/${config.webFormPrefix}/api/createSaleforceLead`)
        .send({
            data: leadFormUserInfo
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, res) => {
            if (error || !res) {
                const errorKey = 'internal.server.error';
                store.dispatch(webFormPageActions.alertError(errorKey));
                store.dispatch(actions.enableLoadOverLay(false));
            } else if (res.statusCode === 204) {
                store.dispatch(actions.changeAppState('WEBFORMINFO_PAGE'));
            } else {
                try {
                    const parsedResponse = res.text ? JSON.parse(res.text) : {};
                    if (parsedResponse.code === 400) {
                        const errorKey = 'ipmob.error.process.request';
                        store.dispatch(webFormPageActions.alertError(errorKey));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else {
                        const errorKey = 'internal.server.error';
                        store.dispatch(webFormPageActions.alertError(errorKey));
                        store.dispatch(actions.enableLoadOverLay(false));
                    }
                } catch (e) {
                    const errorKey = 'internal.server.error';
                    store.dispatch(webFormPageActions.alertError(errorKey));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
        }
        );
}

export default createWebformAccount;
